import { useMutation, useQueryClient } from '@tanstack/react-query'
import { addVideo } from '@/services/youtube.service'

export const YOUTUBE_VIDEOS_QUERY_KEY = 'youtube-videos'

export const useAddYouTubeVideo = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: addVideo,
    onSuccess: (data) => {
      if (data.status === 'success') {
        queryClient.invalidateQueries({ queryKey: [YOUTUBE_VIDEOS_QUERY_KEY] })
      }
      // If status === 'failed' (e.g. duplicate), do NOT invalidate — component handles inline display
    },
  })
}
